import { render, staticRenderFns } from "./Observaciones.vue?vue&type=template&id=13f47d28"
import script from "./Observaciones.vue?vue&type=script&lang=ts"
export * from "./Observaciones.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports